import React from "react";

const PILLAR_COLOR = {
  AMBIENTAL: "#C3E2F7",
  ENVIRONMENTAL: "#C3E2F7",
  SEGURIDAD: "#578EBF",
  SAFETY: "#578EBF",
  SEGURANÇA: "#578EBF",
  SOCIAL: "#FFFFFF",
};

// Rueda 3D de tarjetas de módulos: `axis` define el eje de rotación
// (X = rueda vertical, escritorio · Y = rueda horizontal, móvil).
export function Carousel3D({ axis, modules, cardWidth, cardHeight, translateZ, duration }) {
  const step = 360 / modules.length;

  return (
    <div
      className={`eco-carousel eco-carousel--${axis.toLowerCase()}`}
      style={{
        width: cardWidth,
        height: cardHeight,
        animationDuration: `${duration}s`,
      }}
    >
      {modules.map((mod, i) => (
        <div
          key={i}
          className="eco-carousel__card"
          style={{
            transform: `rotate${axis}(${i * step}deg) translateZ(${translateZ}px)`,
          }}
        >
          <div
            className="eco-carousel__pillar"
            style={{ color: PILLAR_COLOR[mod.pillar] || "#C3E2F7" }}
          >
            {mod.pillar}
          </div>
          <div className="eco-carousel__title">{mod.title}</div>
          <div className="eco-carousel__desc">{mod.desc}</div>
        </div>
      ))}
    </div>
  );
}
